var tabs = document.querySelectorAll('.shogun-tab');
var accordions = document.querySelectorAll('.shogun-accordion');

Array.prototype.slice.call(tabs).forEach(function(tab) {
  tab.addEventListener('click', function(e){
    setTimeout(function(){
      window.dispatchEvent(new Event('resize'));
    }, 200)
  })
})

// Array.prototype.slice.call(accordions).forEach(function(accordion) {
//   accordion.addEventListener('click', function(e){
//     setTimeout(function(){
//       window.dispatchEvent(new Event('resize'));
//     }, 200)
//   })
// })